import React, { useState } from 'react'
import { connect } from "react-redux";
import { Col, Form, Row } from "reactstrap";
import { useForm } from "react-hook-form";


// components
import SpecialOptionComponent from "../tools/SpecialOptionComponent";
import { ButtonCancel, ButtonSubmit } from "../../buttons/buttonsActions";

// actions
import { add } from "../../../redux/actions/todoFluye/wishlistActions";

// labels
import {
    LB_ALLERGIES, LB_ANIVERSARY, LB_BIRTHDAY, LB_CELEBRATIONS,
    LB_HANDICAP, LB_HONEYMOON, LB_OTHERS, LB_PET, LB_SPECIAL_CASES,
} from "../../i18n/i18n";

// utils
import {specialsOptions, wishlistTypes} from "../../../util/WishlistUtils";

const SpecialFormComponent = props => {
    const fbDataBaseId = props.mainState?.app?.fbDataBase?.id
    const { domainObject } = props.formState
    const { wishlist, handleCancel, handleToggle  } = props

    const [birthday , setBirthday ] = useState( domainObject?.birthday || '')
    const [birthdayDate , setBirthdayDate ] = useState( domainObject?.birthdayDate || '')

    const [anniversary , setAnniversary ] = useState( domainObject?.annive || '')
    const [anniversaryDate , setAnniversaryDate ] = useState( domainObject?.anniveDate || '')

    const [honeyMoon , setHoneyMoon ] = useState( domainObject?.honeyMoon || '')
    const [honeyMoonDate , setHoneyMoonDate ] = useState( domainObject?.honeyMoonDate || '')

    const [otherCelebration , setOtherCelebration ] = useState( domainObject?.otherCelebration || '')
    const [otherCelebrationDate , setOtherCelebrationDate ] = useState( domainObject?.otherCelebration || '')

    const [handicap , setHandicap ] = useState( domainObject?.handicap || '')
    const [pet , setPet ] = useState( domainObject?.pet || '')
    const [allergies , setAllergies ] = useState( domainObject?.allergies || '')
    const [otherSpecialCases , setOtherSpecialCases ] = useState( domainObject?.otherSpecialCases || '')

    const { handleSubmit } = useForm();

    const onSubmit = (data, _) => {

        if(birthday == null
        || anniversary == null
        || honeyMoon == null
        || handicap == null
        || pet == null
        || allergies == null
        || otherCelebration == null
        || otherSpecialCases == null ) return

        let dataRequest = {
            fbDataBase: fbDataBaseId,
            item: {
                type: wishlistTypes.special.description,
                wishlist:{ id: wishlist?.id },
                from:'wishlist',
            }
        }

        if(domainObject)
            dataRequest.item.id = domainObject?.id

        if(birthday)
            dataRequest.item.birthday = {
                'code': specialsOptions.birthday.description,
                'comment': birthday,
                'date' : birthdayDate,
            }

        if(anniversary)
            dataRequest.item.anniversary = {
                'code': specialsOptions.anniversary.description,
                'comment':anniversary,
                'date' : anniversaryDate,
            }

        if(honeyMoon)
            dataRequest.item.honeyMoon = {
                'code': specialsOptions.honeyMoon.description,
                'comment': honeyMoon,
                'date' : honeyMoonDate,
            }


        if(otherCelebration)
            dataRequest.item.otherCelebration = {
                'code': specialsOptions.otherCelebration.description,
                'comment': otherCelebration,
                'date' : otherCelebrationDate,
            }

        if(allergies)
            dataRequest.item.allergies = {
                'code':specialsOptions.allergies.description,
                'comment': allergies,
            }


        if(handicap)
            dataRequest.item.handicap = {
                'code': specialsOptions.handicap.description,
                'comment': handicap,
            }

        if(pet)
            dataRequest.item.pet = {
                'code':specialsOptions.pet.description,
                'comment': pet,
            }

        if(otherSpecialCases)
            dataRequest.item.otherSpecialCases = {
                'code': specialsOptions.otherSpecialCases.description,
                'comment': otherSpecialCases,
            }

        props.add( dataRequest, handleToggle )
    }

    return <Form onSubmit={handleSubmit(onSubmit)}>
        <Row className={'mb-2em'}>
            <Col className={'wl-modal-title-item fex-center'}>
                <img
                    src={require(`../../../assets/images/wishlist/${props?.selectedOption?.icon}`)}
                    alt={props?.selectedOption?.title}
                    width={36}
                    height={36}
                />&nbsp; { props?.selectedOption?.title }
            </Col>
        </Row>
        <div className={'wl-card-title'}>
            <Row className={'mb-2em'}>
                <Col className={'fex-center'}>{LB_CELEBRATIONS}</Col>
                <Col className={'fex-center'}>{LB_SPECIAL_CASES}</Col>
            </Row>
        </div>
        <Row>
            <Col>
                <SpecialOptionComponent
                    title={ LB_BIRTHDAY }
                    content = { birthday }
                    wishlist = {wishlist}
                    enabledDate={ true }
                    selectedDate={ birthdayDate }
                    setExternalDate={ setBirthdayDate }
                    setExternalValue = { setBirthday }
                />

                <SpecialOptionComponent
                    title={ LB_ANIVERSARY }
                    content = { anniversary }
                    wishlist = {wishlist}
                    enabledDate={ true }
                    selectedDate={ anniversaryDate }
                    setExternalDate={ setAnniversaryDate }
                    setExternalValue = { setAnniversary }
                />

                <SpecialOptionComponent
                    title={ LB_HONEYMOON }
                    content = { honeyMoon }
                    wishlist = {wishlist}
                    enabledDate={ true }
                    selectedDate={ honeyMoonDate }
                    setExternalDate={ setHoneyMoonDate }
                    setExternalValue = { setHoneyMoon }
                />

                <SpecialOptionComponent
                    title={ LB_OTHERS }
                    content = { otherCelebration }
                    wishlist = {wishlist}
                    enabledDate={ true }
                    selectedDate={ otherCelebrationDate }
                    setExternalDate={ setOtherCelebrationDate }
                    setExternalValue = { setOtherCelebration }
                />
            </Col>
            <Col>
                <SpecialOptionComponent
                    title={ LB_HANDICAP }
                    content = { handicap }
                    setExternalValue = { setHandicap }
                />

                <SpecialOptionComponent
                    title={ LB_ALLERGIES }
                    content = { allergies }
                    setExternalValue = { setAllergies }
                />

                <SpecialOptionComponent
                    title={ LB_PET }
                    content = { pet }
                    setExternalValue = { setPet }
                />

                <SpecialOptionComponent
                    title={ LB_OTHERS }
                    content = { otherSpecialCases }
                    setExternalValue = { setOtherSpecialCases }
                />
            </Col>
        </Row>
        <Row>
            <Col className="d-flex justify-content-center">
                <div>
                    <ButtonSubmit/>
                    <ButtonCancel onClick={ ()=> handleCancel() }/>
                </div>
            </Col>
        </Row>
    </Form>
}

const mapStateToProps = state => ({
    mainState: state.mainProps,
    formState: state.formProps
})
const mapActionsToProps = ({
    add
})

export default connect(mapStateToProps, mapActionsToProps)(SpecialFormComponent)